import * as React from 'react';

var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgFlip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "13 14.5 15 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "flip_svg__a_CC5TOSEI",
    d: "M0 0h44v44H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 29.364h1.667v-1.637H24.5v1.637zm3.333-9.819H29.5V17.91h-1.667v1.636zM14.5 16.273v11.454c0 .9.75 1.637 1.667 1.637H19.5v-1.637h-3.333V16.273H19.5v-1.637h-3.333c-.917 0-1.667.737-1.667 1.637zm13.333-1.637v1.637H29.5c0-.9-.75-1.637-1.667-1.637zM21.167 31h1.666V13h-1.666v18zm6.666-4.91H29.5v-1.636h-1.667v1.637zM24.5 16.274h1.667v-1.637H24.5v1.637zm3.333 6.545H29.5v-1.636h-1.667v1.636zm0 6.546c.917 0 1.667-.737 1.667-1.637h-1.667v1.637z",
    fill: "currentColor"
  })));
}

export { SvgFlip as ReactComponent };
